import React, {useState} from 'react';
import {BrowserRouter, Routes, Route} from 'react-router-dom';
import UserProvider from './context/userContext';
import DeviceProvider from './context/deviceContext';
import SearchAndFilterProvider from './context/searchContext';
import AuthCheck from './fetchRoutes/auth';
import Home from './home/homePage';
import PropertiesPage from './properties/propertiesPage';
import AuctionsPage from './auctions/auctionsPage';
import AuctionSearchAndFilterProvider from './context/auctionFilterContext';
import LoginPage from './login/loginPage';
import RegisterPage from './register/registerPage';
import UpdatePasswordPage from './password/updatePasswordPage';
import PropertyPage from './placeBid/propertyPage';
import SellerDashboardPage from './dashboards/seller/selllerDashboardPage';
import AddPropertyPage from './dashboards/seller/properties/addPropertyPage';
import MyPropertiesPage from './dashboards/seller/myProperties/myPropertiesPage';
import UpdateDetailPage from './dashboards/seller/updateDetail/updateDetailPage';
import BuyerDashboardPage from './dashboards/buyer/buyerDashboardPage';
import FavoritePropertiesPage from './dashboards/buyer/favoriteProperties/favoritesPropertiesPage';
import MyBidsPage from './dashboards/buyer/bidsHistory/myBidsPage';
import UpdateBuyerDetailPage from './dashboards/buyer/updateDetail/updateDetailPage';
import ChatPage from './dashboards/seller/chat/chatPage';
import MyWonPropertiesPage from './dashboards/buyer/myProperties/myPropertiesPage';
import AccessDenied from './utility/accessDenied';
import PageNotFound from './utility/pageNotFound';
import ProtectedRoute from './utility/protectedRoutes';
import AdminDashboardPage from './dashboards/admin/adminDashboardPage';
import ManageUsersPage from './dashboards/admin/users/manageUserPage';
import ManagePropertiesPage from './dashboards/admin/properties/managePropertiesPage';
import ManagePaymentsPage from './dashboards/admin/payments/managePaymentsPage';
import PaymentSuccessPage from './utility/paymentSuccessful';
import PaymentCancelledPage from './utility/paymentCancelled';
import PasswordGate from './utility/passwordGate';


function App() {

  const [accessGranted, setAccessGranted] = useState(false);

  if (!accessGranted) {
    return <PasswordGate onAccessGranted={() => setAccessGranted(true)} />;
  }
  
  return (
    <BrowserRouter>
      <UserProvider>
        <DeviceProvider>
            <AuthCheck />
            <Routes>
              <Route exact path="/" element={<Home />} />
              
              {/* Properties page */}
              <Route exact path="/properties" 
                element={
                  <SearchAndFilterProvider>
                    <PropertiesPage />
                  </SearchAndFilterProvider>
                } 
              />

              {/* Auctions page */}
              <Route exact path="/auctions" element={
                <AuctionSearchAndFilterProvider>
                  <AuctionsPage />
                </AuctionSearchAndFilterProvider>
              } />

              {/* General Routes */}
              <Route exact path="/account/login" element={<LoginPage />} />
              <Route exact path="/account/register" element={<RegisterPage />} />
              <Route exact path="/account/updatePassword" element={<UpdatePasswordPage />} />
              <Route exact path="/properties/property/:id" element={<PropertyPage/>} />
              
              {/* Seller Routes */}
              <Route exact path="/seller/dashboard" element={
                <ProtectedRoute requiredRole="seller">
                  <SellerDashboardPage />
                </ProtectedRoute>
              }/>

              <Route exact path='/seller/add-property' element={
                  <ProtectedRoute requiredRole="seller">
                    <AddPropertyPage/>                
                  </ProtectedRoute>
              }/>

            
              <Route exact path='/seller/my-properties' element={
                <ProtectedRoute requiredRole="seller">
                  <MyPropertiesPage/>                
                </ProtectedRoute>
              }/>


              <Route exact path='/seller/update-details' element={
                <ProtectedRoute requiredRole="seller">
                  <UpdateDetailPage/>                
                </ProtectedRoute>
              }/>


              <Route exact path='/seller/chat' element={
                <ProtectedRoute requiredRole="seller">
                  <ChatPage />              
                </ProtectedRoute>
              } />


              {/* Buyer Routes */}
              <Route exact path="/buyer/dashboard" element={
                <ProtectedRoute requiredRole="buyer">
                  <BuyerDashboardPage/>
                </ProtectedRoute>
              }/>

              <Route exact path='/buyer/favorite-properties' element={
                <ProtectedRoute requiredRole="buyer">
                  <FavoritePropertiesPage />
                </ProtectedRoute>
              } />

              <Route exact path='/buyer/my-bids' element={
                <ProtectedRoute requiredRole="buyer">
                  <MyBidsPage />
                </ProtectedRoute>
              } />

              <Route exact path='/buyer/update-details' element={
                <ProtectedRoute requiredRole="buyer">
                  <UpdateBuyerDetailPage />
                </ProtectedRoute>
              } />

              <Route exact path='/buyer/won-properties' element={
                <ProtectedRoute requiredRole="buyer">
                  <MyWonPropertiesPage />
                </ProtectedRoute>
              } />


              {/* Admin Routes */}
              <Route exact path="/admin/dashboard" element={
                <ProtectedRoute requiredRole="admin">
                  <AdminDashboardPage/>
                </ProtectedRoute>
              }/>

              <Route exact path="/admin/users" element={
                <ProtectedRoute requiredRole="admin">
                  <ManageUsersPage/>
                </ProtectedRoute>
              }/>

              <Route exact path="/admin/properties" element={
                <ProtectedRoute requiredRole="admin">
                  <ManagePropertiesPage/>
                </ProtectedRoute>
              }/>


              <Route exact path="/admin/payments" element={
                <ProtectedRoute requiredRole="admin">
                  <ManagePaymentsPage/>
                </ProtectedRoute>
              }/>

              <Route exact path='/accessDenied' element={<AccessDenied/>}/>

              {/* Route for successful payment page */}
              <Route exact path="/payment/success" element={<PaymentSuccessPage/>} />

              <Route exact path="/payment/cancelled" element={<PaymentCancelledPage/>} />


              {/* 404 Page Not Found */}
              <Route path='*' element={<PageNotFound />} />

            </Routes>
        </DeviceProvider>
      </UserProvider>
    </BrowserRouter>
  );
}

export default App;
